import { Link } from 'react-router-dom'
import styled from 'styled-components'
import {
  P,
  Wrapper,
  AttachmentIcon,
  ExternalGoogleDriveIcon,
} from '@farewill/ui'
import { BORDER, COLOR, FONT, GTR } from '@farewill/ui/tokens'
import type { DocumentWithAttributes } from 'lib/models/document'
import { getUploadedByWithTime, getSavedByWithTime } from '../helpers'

const StyledDocumentCard = styled(Wrapper)`
  border-radius: ${BORDER.RADIUS.M};
  border-color: ${COLOR.GREY.LIGHT};
  border-style: solid;
  border-width: 1px;
`

const StyledWrapper = styled(Wrapper)`
  display: flex;
  align-items: center;
  gap: ${GTR.XXS};
`

const StyledDocumentLink = styled(Link)`
  display: inline-block;
  font-size: ${FONT.SIZE.M};
  line-height: 1;
`

const StyledExternalDocumentLink = styled.a`
  display: inline-block;
  font-size: ${FONT.SIZE.M};
  line-height: 1;
`

const StyledActivityTimestamp = styled(P)`
  color: ${COLOR.GREY.DARK};
  font-size: ${FONT.SIZE.XS};
  margin: 0;
`

export const DocumentCardSaved = ({
  document,
}: {
  document: DocumentWithAttributes
}) => {
  const isGoogleDriveDoc =
    document.attributes.files[0]?.source === 'google_drive'

  return (
    <StyledDocumentCard
      tag="li"
      key={document.id}
      margin={['0', '0', GTR.S, '0']}
      padding="S"
      background={COLOR.WHITE}
    >
      <StyledWrapper margin={['0', '0', GTR.XXS, '0']}>
        {isGoogleDriveDoc ? (
          <ExternalGoogleDriveIcon color={COLOR.GREY.DARK} size="S" />
        ) : (
          <AttachmentIcon color={COLOR.GREY.DARK} size="S" />
        )}
        <Wrapper>
          {isGoogleDriveDoc && (
            <StyledExternalDocumentLink
              href={document.attributes.files[0].url}
              target="_blank"
              rel="noreferrer noopener"
            >
              {document.attributes.title}
            </StyledExternalDocumentLink>
          )}
          {!isGoogleDriveDoc && (
            <StyledDocumentLink
              to={`/probate/cases/${document.attributes.probateCaseId}/documents/${document.id}`}
            >
              {document.attributes.title}
            </StyledDocumentLink>
          )}
        </Wrapper>
      </StyledWrapper>
      <StyledActivityTimestamp>
        {getUploadedByWithTime(document)}
        {' · '}
        {getSavedByWithTime(document)}
      </StyledActivityTimestamp>
    </StyledDocumentCard>
  )
}
